import NgaVenueConfigList from './nga-venue-config-view';

const NgaVenueConfigPage = {
    name: 'NgaVenueConfig',
    list: NgaVenueConfigList
};
export default NgaVenueConfigPage;